// Replace `url` with your production domain before deploying (also update public/robots.txt and public/sitemap.xml).
export const site = {
  name: 'The Automation Brief',
  url: 'https://www.yourdomain.co.uk',
  path: '/',
  title: 'Top AI Workflow Automation Service Provider Companies in England',
  metaTitle: 'Top AI Workflow Automation Companies in England (2026 Guide)',
  description:
    'Compare five AI workflow automation service providers in England: tkxel, Swarm Labs, flowio, Ferrous Labs and The Automation Consultants. Use cases, governance, ROI and a 10-step plan.',
  ogImage:
    'https://cdn.magicpatterns.com/patterns/generated-images/4164c409-ca43-40d6-95bc-a575c1d230bf.jpg',
  ogImageAlt:
    'Illustration of an AI workflow pipeline where emails and documents flow through a glowing AI core into analytics dashboards and a completed approval step',
  published: '2026-09-24',
  modified: '2026-09-24',
  publishedLabel: '24 September 2026',
  readingTime: '12 min read',
  tkxelServiceUrl: 'https://tkxel.com/services/ai-workflow-automation/',
} as const;

export const canonicalUrl = `${site.url}${site.path}`;

// Replace profile URLs with the author's real LinkedIn and WhatsApp links.
export const author = {
  name: 'Muhammad Dawood Khan',
  initials: 'MK',
  role: 'Technology Writer, AI & Automation',
  bio: 'Muhammad Dawood Khan writes about AI adoption, workflow automation and digital transformation, with a focus on practical guidance for business and technology leaders choosing an implementation partner.',
  linkedin: 'https://www.linkedin.com/in/muhammad-dawood-khan/',
  whatsapp: 'https://wa.me/447000000000',
} as const;

// Contextual links — replace each href with the exact URL from the project brief.
export const contextualLinks = {
  agentsCanada: {
    anchor: 'ai agents development compaines in canada',
    href: 'https://www.yourdomain.co.uk/replace-with-brief-url/ai-agents-development-companies-canada/',
  },
  chatbotUsa: {
    anchor: 'ai chatbot development companies in usa',
    href: 'https://www.yourdomain.co.uk/replace-with-brief-url/ai-chatbot-development-companies-usa/',
  },
  governanceUsa: {
    anchor: 'AI Governance solutions in usa',
    href: 'https://www.yourdomain.co.uk/replace-with-brief-url/ai-governance-solutions-usa/',
  },
  developmentAlabama: {
    anchor: 'AI Development Service Provider Companies in Alabama',
    href: 'https://www.yourdomain.co.uk/replace-with-brief-url/ai-development-companies-alabama/',
  },
  serviceGermany: {
    anchor: 'ai service provider companies in Germany',
    href: 'https://www.yourdomain.co.uk/replace-with-brief-url/ai-service-provider-companies-germany/',
  },
} as const;
